<!--
 * @Description: 统计报表
 * @Author: 景 彡
 * @Date: 2024-11-08 11:39:09
 * @LastEditors: 景 彡
-->
<template>
  <div class="p-16px">
    <div class="grid grid-cols-[repeat(3,minmax(300px,1fr))] gap-16px">
      <!-- 兑换订单报表 -->
      <a-card :loading="loading.redemption" title="兑换订单报表" class="hover:shadow-lg">
        <div class="space-y-8px">
          <div class="flex justify-between">
            <span class="text-gray-600">总订单数</span>
            <span class="text-blue-600 font-bold">{{ summary.redemption?.totalOrders || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">总兑换积分</span>
            <span class="font-bold">{{ summary.redemption?.totalPoints || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">待发货</span>
            <span class="text-orange-500 font-bold">{{ summary.redemption?.pendingShipmentOrders || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">已发货</span>
            <span class="text-green-600 font-bold">{{ summary.redemption?.shippedOrders || 0 }}</span>
          </div>
        </div>
        <template #actions>
          <div class="flex justify-center gap-8px">
            <a-button size="small" @click="handleRefresh('redemption')">
              <template #icon>
                <ReloadOutlined />
              </template>
              刷新
            </a-button>
            <a-button type="primary" size="small" @click="openFilterModal('redemption')">
              导出
            </a-button>
          </div>
        </template>
      </a-card>

      <!-- 推广情况报表 -->
      <a-card :loading="loading.promotion" title="推广情况报表" class="hover:shadow-lg">
        <div class="space-y-8px">
          <div class="flex justify-between">
            <span class="text-gray-600">总推广记录</span>
            <span class="text-blue-600 font-bold">{{ summary.promotion?.totalReferrals || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">已发放奖励</span>
            <span class="text-green-600 font-bold">{{ summary.promotion?.rewardedReferrals || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">待发放奖励</span>
            <span class="text-orange-500 font-bold">{{ summary.promotion?.pendingRewards || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">参与推广用户</span>
            <span class="font-bold">{{ summary.promotion?.promoterCount || 0 }}</span>
          </div>
        </div>
        <template #actions>
          <div class="flex justify-center gap-8px">
            <a-button size="small" @click="handleRefresh('promotion')">
              <template #icon>
                <ReloadOutlined />
              </template>
              刷新
            </a-button>
            <a-button type="primary" size="small" @click="openFilterModal('promotion')">
              导出
            </a-button>
          </div>
        </template>
      </a-card>

      <!-- 二维码生产报表 -->
      <a-card :loading="loading.qrcode" title="二维码生产报表" class="hover:shadow-lg">
        <div class="space-y-8px">
          <div class="flex justify-between">
            <span class="text-gray-600">总二维码数</span>
            <span class="text-blue-600 font-bold">{{ summary.qrcode?.totalQRCode || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">未使用</span>
            <span class="font-bold">{{ summary.qrcode?.unusedCount || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">已使用</span>
            <span class="text-green-600 font-bold">{{ summary.qrcode?.usedCount || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">已过期</span>
            <span class="text-red-500 font-bold">{{ summary.qrcode?.expiredCount || 0 }}</span>
          </div>
        </div>
        <template #actions>
          <div class="flex justify-center gap-8px">
            <a-button size="small" @click="handleRefresh('qrcode')">
              <template #icon>
                <ReloadOutlined />
              </template>
              刷新
            </a-button>
            <a-button type="primary" size="small" @click="openFilterModal('qrcode')">
              导出
            </a-button>
          </div>
        </template>
      </a-card>

      <!-- 产品激活报表 -->
      <a-card :loading="loading.activation" title="产品激活报表" class="hover:shadow-lg">
        <div class="space-y-8px">
          <div class="flex justify-between">
            <span class="text-gray-600">总激活数</span>
            <span class="text-blue-600 font-bold">{{ summary.activation?.totalActivations || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">成功激活</span>
            <span class="text-green-600 font-bold">{{ summary.activation?.successfulActivations || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">二次扫码</span>
            <span class="font-bold">{{ summary.activation?.reactivatedCount || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">异常数</span>
            <span class="text-red-500 font-bold">{{ summary.activation?.errorCount || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">总发放积分</span>
            <span class="font-bold">{{ summary.activation?.totalPointsGranted || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">总发放返现</span>
            <span class="text-green-600 font-bold">¥{{ fenToYuan(summary.activation?.totalCashbackGranted || 0) }}</span>
          </div>
        </div>
        <template #actions>
          <div class="flex justify-center gap-8px">
            <a-button size="small" @click="handleRefresh('activation')">
              <template #icon>
                <ReloadOutlined />
              </template>
              刷新
            </a-button>
            <a-button type="primary" size="small" @click="openFilterModal('activation')">
              导出
            </a-button>
          </div>
        </template>
      </a-card>

      <!-- 积分报表 -->
      <a-card :loading="loading.points" title="积分报表" class="hover:shadow-lg">
        <div class="space-y-8px">
          <div class="flex justify-between">
            <span class="text-gray-600">总记录数</span>
            <span class="text-blue-600 font-bold">{{ summary.points?.totalRecords || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">总增加积分</span>
            <span class="text-green-600 font-bold">{{ summary.points?.totalAddedPoints || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">总减少积分</span>
            <span class="text-red-500 font-bold">{{ summary.points?.totalReducedPoints || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">净增加积分</span>
            <span class="font-bold">{{ summary.points?.netPointsChange || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">涉及用户数</span>
            <span class="font-bold">{{ summary.points?.userCount || 0 }}</span>
          </div>
        </div>
        <template #actions>
          <div class="flex justify-center gap-8px">
            <a-button size="small" @click="handleRefresh('points')">
              <template #icon>
                <ReloadOutlined />
              </template>
              刷新
            </a-button>
            <a-button type="primary" size="small" @click="openFilterModal('points')">
              导出
            </a-button>
          </div>
        </template>
      </a-card>

      <!-- 现金红包报表 -->
      <a-card :loading="loading.cash" title="现金红包报表" class="hover:shadow-lg">
        <div class="space-y-8px">
          <div class="flex justify-between">
            <span class="text-gray-600">总记录数</span>
            <span class="text-blue-600 font-bold">{{ summary.cash?.totalRecords || 0 }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">总金额</span>
            <span class="text-green-600 font-bold">¥{{ fenToYuan(summary.cash?.totalAmount || 0) }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">已发放金额</span>
            <span class="text-green-600 font-bold">¥{{ fenToYuan(summary.cash?.grantedAmount || 0) }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">待发放金额</span>
            <span class="text-orange-500 font-bold">¥{{ fenToYuan(summary.cash?.pendingAmount || 0) }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">涉及用户数</span>
            <span class="font-bold">{{ summary.cash?.userCount || 0 }}</span>
          </div>
        </div>
        <template #actions>
          <div class="flex justify-center gap-8px">
            <a-button size="small" @click="handleRefresh('cash')">
              <template #icon>
                <ReloadOutlined />
              </template>
              刷新
            </a-button>
            <a-button type="primary" size="small" @click="openFilterModal('cash')">
              导出
            </a-button>
          </div>
        </template>
      </a-card>
    </div>

    <!-- 导出筛选条件模态框 -->
    <a-modal
      v-model:open="filterModalVisible"
      :title="currentReportTitle"
      :confirm-loading="exporting"
      @ok="handleExport"
      @cancel="closeFilterModal"
    >
      <a-form :model="filterForm" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="开始时间">
              <a-date-picker
                v-model:value="filterForm.startTime"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结束时间">
              <a-date-picker
                v-model:value="filterForm.endTime"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 兑换订单报表筛选 -->
        <template v-if="currentReportType === 'redemption'">
          <a-form-item label="订单编号">
            <a-input v-model:value="filterForm.orderNumber" placeholder="请输入订单编号" />
          </a-form-item>
          <a-form-item label="商品信息关键词">
            <a-input v-model:value="filterForm.keyword" placeholder="请输入商品信息关键词" />
          </a-form-item>
          <a-form-item label="用户信息关键词">
            <a-input v-model:value="filterForm.userKeyword" placeholder="请输入用户姓名/手机号" />
          </a-form-item>
        </template>

        <!-- 推广情况报表筛选 -->
        <template v-if="currentReportType === 'promotion'">
          <a-form-item label="推广用户关键词">
            <a-input v-model:value="filterForm.promoterKeyword" placeholder="请输入推广用户关键词" />
          </a-form-item>
          <a-form-item label="被推广用户关键词">
            <a-input v-model:value="filterForm.referredKeyword" placeholder="请输入被推广用户关键词" />
          </a-form-item>
          <a-form-item label="是否只统计已发放奖励">
            <a-switch v-model:checked="filterForm.onlyRewarded" />
          </a-form-item>
        </template>

        <!-- 二维码生产报表筛选 -->
        <template v-if="currentReportType === 'qrcode'">
          <a-form-item label="防伪码状态">
            <a-select v-model:value="filterForm.status" placeholder="请选择状态" allow-clear>
              <a-select-option value="unused">未使用</a-select-option>
              <a-select-option value="used">已使用</a-select-option>
              <a-select-option value="expired">已过期</a-select-option>
            </a-select>
          </a-form-item>
        </template>

        <!-- 产品激活报表筛选 -->
        <template v-if="currentReportType === 'activation'">
          <a-form-item label="用户关键词">
            <a-input v-model:value="filterForm.userKeyword" placeholder="请输入用户关键词" />
          </a-form-item>
          <a-form-item label="是否只统计已激活">
            <a-switch v-model:checked="filterForm.onlyActivated" />
          </a-form-item>
          <a-form-item label="是否包含二次扫码">
            <a-switch v-model:checked="filterForm.includeReactivated" />
          </a-form-item>
          <a-form-item label="是否包含异常记录">
            <a-switch v-model:checked="filterForm.includeError" />
          </a-form-item>
        </template>

        <!-- 积分报表筛选 -->
        <template v-if="currentReportType === 'points'">
          <a-form-item label="用户关键词">
            <a-input v-model:value="filterForm.userKeyword" placeholder="请输入用户关键词" />
          </a-form-item>
          <a-form-item label="操作类型">
            <a-radio-group v-model:value="filterForm.opType">
              <a-radio :value="null">全部</a-radio>
              <a-radio :value="true">增加</a-radio>
              <a-radio :value="false">减少</a-radio>
            </a-radio-group>
          </a-form-item>
        </template>

        <!-- 现金红包报表筛选 -->
        <template v-if="currentReportType === 'cash'">
          <a-form-item label="用户关键词">
            <a-input v-model:value="filterForm.userKeyword" placeholder="请输入用户关键词" />
          </a-form-item>
          <a-form-item label="发放状态">
            <a-select v-model:value="filterForm.status" placeholder="请选择状态" allow-clear>
              <a-select-option value="pending">待发放</a-select-option>
              <a-select-option value="granted">已发放</a-select-option>
            </a-select>
          </a-form-item>
        </template>
      </a-form>
    </a-modal>
  </div>
</template>

<script lang='ts' setup>
import type { CashRedPacketReportSummary } from '@/.generated/models/CashRedPacketReportSummary'
import type { PointsReportSummary } from '@/.generated/models/PointsReportSummary'
import type { ProductActivationReportSummary } from '@/.generated/models/ProductActivationReportSummary'
import type { PromotionReportSummary } from '@/.generated/models/PromotionReportSummary'
import type { QRCodeProductionReportSummary } from '@/.generated/models/QRCodeProductionReportSummary'
import type { RedemptionOrderReportSummary } from '@/.generated/models/RedemptionOrderReportSummary'
import * as api from '@/.generated/apis'
import { CashRedPacketReportQuery } from '@/.generated/models/CashRedPacketReportQuery'
import { PointsReportQuery } from '@/.generated/models/PointsReportQuery'
import { ProductActivationReportQuery } from '@/.generated/models/ProductActivationReportQuery'
import { PromotionReportQuery } from '@/.generated/models/PromotionReportQuery'
import { QRCodeProductionReportQuery } from '@/.generated/models/QRCodeProductionReportQuery'
import { RedemptionOrderReportQuery } from '@/.generated/models/RedemptionOrderReportQuery'
import { ReloadOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'

definePage({
  meta: {
    title: '统计报表',
    layoutRoute: {
      meta: { layout: 'admin', title: '统计报表', local: true, icon: 'BarChartOutlined', order: 3 },
    },
  },
})

// 定义报表摘要数据
const summary = ref({
  redemption: null as RedemptionOrderReportSummary | null,
  promotion: null as PromotionReportSummary | null,
  qrcode: null as QRCodeProductionReportSummary | null,
  activation: null as ProductActivationReportSummary | null,
  points: null as PointsReportSummary | null,
  cash: null as CashRedPacketReportSummary | null,
} as { [key: string]: any })

// 定义加载状态
const loading = ref({
  redemption: false,
  promotion: false,
  qrcode: false,
  activation: false,
  points: false,
  cash: false,
} as { [key: string]: boolean })

// 导出相关状态
const filterModalVisible = ref(false)
const currentReportType = ref('')
const exporting = ref(false)
const filterForm = ref<any>({})

// 金额转换函数（分转元）
function fenToYuan(fen: number): string {
  return (fen / 100).toFixed(2)
}

// 报表标题映射
const reportTitleMap: Record<string, string> = {
  redemption: '兑换订单报表',
  promotion: '推广情况报表',
  qrcode: '二维码生产报表',
  activation: '产品激活报表',
  points: '积分报表',
  cash: '现金红包报表',
}

const currentReportTitle = computed(() => reportTitleMap[currentReportType.value] || '报表导出')

// 策略模式：查询构建策略映射
const queryBuilderMap = {
  redemption: (form: any) => {
    const query = new RedemptionOrderReportQuery()
    const startTime = form.startTime ? dayjs(form.startTime) : null
    const endTime = form.endTime ? dayjs(form.endTime) : null
    query.orderNumber = form.orderNumber || null
    query.keyword = form.keyword || null
    query.userKeyword = form.userKeyword || null
    query.startTime = startTime
    query.endTime = endTime
    return query
  },
  promotion: (form: any) => {
    const query = new PromotionReportQuery()
    const startTime = form.startTime ? dayjs(form.startTime) : null
    const endTime = form.endTime ? dayjs(form.endTime) : null
    query.promoterKeyword = form.promoterKeyword || null
    query.referredKeyword = form.referredKeyword || null
    query.onlyRewarded = form.onlyRewarded || false
    query.startTime = startTime
    query.endTime = endTime
    return query
  },
  qrcode: (form: any) => {
    const query = new QRCodeProductionReportQuery()
    const startTime = form.startTime ? dayjs(form.startTime) : null
    const endTime = form.endTime ? dayjs(form.endTime) : null
    query.status = form.status || null
    query.startTime = startTime
    query.endTime = endTime
    return query
  },
  activation: (form: any) => {
    const query = new ProductActivationReportQuery()
    const startTime = form.startTime ? dayjs(form.startTime) : null
    const endTime = form.endTime ? dayjs(form.endTime) : null
    query.userKeyword = form.userKeyword || null
    query.onlyActivated = form.onlyActivated || false
    query.includeReactivated = form.includeReactivated || false
    query.includeError = form.includeError || false
    query.startTime = startTime
    query.endTime = endTime
    return query
  },
  points: (form: any) => {
    const query = new PointsReportQuery()
    const startTime = form.startTime ? dayjs(form.startTime) : null
    const endTime = form.endTime ? dayjs(form.endTime) : null
    query.userKeyword = form.userKeyword || null
    query.opType = form.opType ?? null
    query.startTime = startTime
    query.endTime = endTime
    return query
  },
  cash: (form: any) => {
    const query = new CashRedPacketReportQuery()
    const startTime = form.startTime ? dayjs(form.startTime) : null
    const endTime = form.endTime ? dayjs(form.endTime) : null
    query.userKeyword = form.userKeyword || null
    query.status = form.status || null
    query.startTime = startTime
    query.endTime = endTime
    return query
  },
}

// 策略模式：导出API策略映射
const exportApiMap = {
  redemption: (query: any) => api.StatisticsReports.ExportRedemptionOrderReport_PostAsync(query),
  promotion: (query: any) => api.StatisticsReports.ExportPromotionReport_PostAsync(query),
  qrcode: (query: any) => api.StatisticsReports.ExportQrCodeProductionReport_PostAsync(query),
  activation: (query: any) => api.StatisticsReports.ExportProductActivationReport_PostAsync(query),
  points: (query: any) => api.StatisticsReports.ExportPointsReport_PostAsync(query),
  cash: (query: any) => api.StatisticsReports.ExportCashRedPacketReport_PostAsync(query),
}

// 策略模式：摘要API策略映射
const summaryApiMap: Record<string, (clearCache: boolean) => Promise<any>> = {
  redemption: (clearCache: boolean) => {
    const query = new RedemptionOrderReportQuery()
    query.clearCache = clearCache
    return api.StatisticsReports.GetRedemptionOrderReportSummary_PostAsync(query)
  },
  promotion: (clearCache: boolean) => {
    const query = new PromotionReportQuery()
    query.clearCache = clearCache
    return api.StatisticsReports.GetPromotionReportSummary_PostAsync(query)
  },
  qrcode: (clearCache: boolean) => {
    const query = new QRCodeProductionReportQuery()
    query.clearCache = clearCache
    return api.StatisticsReports.GetQrCodeProductionReportSummary_PostAsync(query)
  },
  activation: (clearCache: boolean) => {
    const query = new ProductActivationReportQuery()
    query.clearCache = clearCache
    return api.StatisticsReports.GetProductActivationReportSummary_PostAsync(query)
  },
  points: (clearCache: boolean) => {
    const query = new PointsReportQuery()
    query.clearCache = clearCache
    return api.StatisticsReports.GetPointsReportSummary_PostAsync(query)
  },
  cash: (clearCache: boolean) => {
    const query = new CashRedPacketReportQuery()
    query.clearCache = clearCache
    return api.StatisticsReports.GetCashRedPacketReportSummary_PostAsync(query)
  },
}

// 获取单个报表摘要数据
async function fetchSummary(type: string, clearCache = false) {
  const validType = type as keyof typeof summaryApiMap
  loading.value[validType] = true
  try {
    const apiFunction = summaryApiMap[validType]
    if (apiFunction) {
      const data = await apiFunction(clearCache)
      summary.value[validType] = data
    }
  }
  catch (error: any) {
    console.error(`获取${reportTitleMap[type]}失败:`, error)
  }
  finally {
    loading.value[validType] = false
  }
}

// 渐进式加载所有报表摘要数据
async function fetchAllSummaries(clearCache = false) {
  // 定义加载顺序（按优先级分组，优先加载重要报表）
  const loadOrder = [
    ['redemption', 'promotion'], // 第一批：最重要的两个报表
    ['qrcode', 'activation'], // 第二批：中等重要
    ['points', 'cash'], // 第三批：其他报表
  ] as const

  // 分批次渐进式加载
  for (const batch of loadOrder) {
    // 每一批并行加载
    await Promise.all(
      batch.map(type => fetchSummary(type, clearCache)),
    )
  }
}

// 强制刷新单个报表（清除缓存）
async function handleRefresh(type: keyof typeof summaryApiMap) {
  try {
    await fetchSummary(type, true)
    message.success(`${reportTitleMap[type]}刷新成功`)
  }
  catch (error: any) {
    console.error('刷新失败:', error)
    message.error(error.message || '刷新失败')
  }
}

// 打开筛选模态框
function openFilterModal(type: string) {
  currentReportType.value = type
  filterForm.value = {}
  filterModalVisible.value = true
}

// 关闭筛选模态框
function closeFilterModal() {
  filterModalVisible.value = false
  currentReportType.value = ''
  filterForm.value = {}
}

// 构建查询参数（使用策略模式）
function buildQuery() {
  const builder = queryBuilderMap[currentReportType.value as keyof typeof queryBuilderMap]
  return builder ? builder(filterForm.value) : null
}

// 执行导出（使用策略模式）
async function handleExport() {
  exporting.value = true

  try {
    const query = buildQuery()
    if (!query) {
      message.error('报表类型错误')
      return
    }

    const exportApi = exportApiMap[currentReportType.value as keyof typeof exportApiMap]
    if (!exportApi) {
      message.error('不支持的报表类型')
      return
    }

    await useDownload(
      () => exportApi(query),
      `${reportTitleMap[currentReportType.value]}_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}`,
      false,
      '.xlsx',
    )

    message.success('导出成功')
    closeFilterModal()
  }
  catch (error: any) {
    console.error('导出失败:', error)
    message.error(error.message || '导出失败')
  }
  finally {
    exporting.value = false
  }
}

onMounted(() => {
  fetchAllSummaries()
})
</script>

<style scoped>
</style>
